import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  redirectToPhotoTime,
  redirectToConfirmationPhotoDocument,
  redirectToValidationAccessCode,
} from '../../ducks/Navigate';
import {updateDadosDocumentoImage} from '../../ducks/Customer';
import Camera, {IMAGE_TYPES, FACING_MODES} from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class TakePictureDocument extends Component {
  state = {
    alturaCamera: 0,
  };

  isVerso = () => this.props.verso;

  componentDidMount() {
    document.title = this.isVerso()
      ? StringService.formatTitle(RouteKeys.TakeYourPictureDocumentBack)
      : StringService.formatTitle(RouteKeys.TakeYourPictureDocument);
    window.addEventListener('resize', this.ajustaAlturaDoVideo);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.ajustaAlturaDoVideo);
  }

  pickHandle = (dataUri) => {
    const prop = this.isVerso() ? 'verso' : 'frente';
    const value = dataUri;

    this.props.updateDadosDocumentoImage({prop, value});
    this.props.redirectToConfirmationPhotoDocument(this.isVerso());
  };

  handleCameraError = (error) => {
    console.log(error);
    alert(
      'Infelizmente seu dispositivo não é compatível com a utilização da câmera.',
    );
    this.props.redirectToValidationAccessCode();
  };

  ajustaAlturaDoVideo = () => {
    let alturaCamera = document.getElementsByClassName(
      'react-html5-camera-photo',
    )[0].offsetHeight;
    let head = document.getElementsByClassName('head')[0];

    // adiciona margem de seguranca de 20px
    head.style.height = (alturaCamera - 20).toString() + 'px';
    head.style.display = 'inherit';
    this.setState({alturaCamera});
  };

  renderTitle = () => {
    if (this.isVerso()) return 'no verso.';
    else return 'de frente.';
  };

  render() {
    return (
      <div className="div-take-picture-document">
        <div className="container-titulo">
          <p className="info-h1">
            Posicione seu documento, {this.renderTitle()}
          </p>
          <p className="info-h1">Se possível, sem o plástico.</p>
        </div>

        <div className="container-video">
          <img src="/img/area-foto.svg" alt="" className="head" />

          <Camera
            onCameraStart={() => {
              setTimeout(() => {
                this.ajustaAlturaDoVideo();
              }, 500);
            }}
            isDisplayStartCameraError={false}
            onCameraError={(error) => {
              this.handleCameraError(error);
            }}
            isImageMirror={false}
            imageType={IMAGE_TYPES.JPG}
            onTakePhoto={(dataUri) => {
              this.pickHandle(dataUri);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            isSilentMode={true}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  console.log(customer.dadosDocumento);
  return {
    ...customer.dadosDocumento,
  };
};

export default connect(mapStateToProps, {
  redirectToPhotoTime,
  redirectToConfirmationPhotoDocument,
  redirectToValidationAccessCode,
  updateDadosDocumentoImage,
})(TakePictureDocument);
